<template>
  <div class="overview-tab">
    <information-block ref="infoBlock"></information-block>
    <top-present-table
      ref="topPresentTable"
      :defaultTerms="filteringOptions.defaultTerms"
      :defaultClasses="filteringOptions.defaultClasses"
    ></top-present-table>
  </div>
</template>

<script>
import InformationBlock from "./Information";
import TopPresentTable from "./TopPresent";
import { filterOptions as filterOptMixins } from "./mixins";
import { getId } from "@/helpers/utils";

export default {
  components: { InformationBlock, TopPresentTable },
  mixins: [filterOptMixins],
  data() {
    return {
      filteringOptions: {
        defaultTerms: [],
        defaultClasses: []
      }
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      try {
        const terms = await this.fetchTerms();
        const firstTermId = getId(terms[0]);
        const classes = await this.fetchClasses(firstTermId);

        this.$set(this.filteringOptions, "defaultTerms", terms);
        this.$set(this.filteringOptions, "defaultClasses", classes);
      } catch (error) {}
    }
  },
  provide() {
    return {
      filteringOptions: this.filteringOptions
    };
  }
};
</script>

<style lang="scss" scoped></style>
